"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnAuthenticated = exports.SECTION_KEY = void 0;
var tslib_1 = require("tslib");
/* eslint-disable no-console */
var asg_1 = require("@alinta-digital/asg");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var types_1 = require("../../../types");
var components_1 = require("../../../components");
var icons_1 = require("@alinta-digital/asg/icons");
var formik_1 = require("formik");
var TabGroup_1 = (0, tslib_1.__importDefault)(require("../../../components/TabGroup"));
var PayPalButton_1 = (0, tslib_1.__importDefault)(require("../../../components/PayPayButton/PayPalButton"));
var usePayWithPayPal_1 = require("../../../hooks/usePayWithPayPal");
var useCustomCheckoutInstance_1 = require("../../../hooks/useCustomCheckoutInstance");
var client_1 = require("@apollo/client");
var myaccount_frontend_shared_1 = require("@alinta-digital/myaccount-frontend-shared");
exports.SECTION_KEY = 'paymentDetails';
var UnAuthenticated = function (_a) {
    var _b, _c, _d;
    var baseURL = _a.baseURL, skipMountingScript = _a.skipMountingScript, bamboraURL = _a.bamboraURL, guid = _a.guid, currentStepKey = _a.currentStepKey, nextStepKey = _a.nextStepKey, onCancel = _a.onCancel, onSubmit = _a.onSubmit, ga = _a.ga;
    var responsiveSize = (0, react_1.useContext)(asg_1.ResponsiveContext);
    var _e = (0, react_1.useContext)(asg_1.StepsContext), goToStep = _e.goToStep, completeStep = _e.completeStep, steps = _e.steps;
    var formikState = (0, formik_1.useFormikContext)();
    var paymentDetails = formikState.values.paymentDetails;
    var _f = (0, react_1.useState)(false), loading = _f[0], setLoading = _f[1];
    var _g = (0, react_1.useState)(types_1.PaymentCardType.EMPTY), cardType = _g[0], setCardType = _g[1];
    var _h = (0, react_1.useState)(paymentDetails.savedPaymentId ? true : false), isCardValid = _h[0], setIsCardValid = _h[1];
    var instance = (0, useCustomCheckoutInstance_1.useCustomCheckoutInstance)(bamboraURL, skipMountingScript);
    var tabTitles = (0, react_1.useMemo)(function () { return ['Credit or Debit Card', 'PayPal']; }, []);
    var appBaseUrl = baseURL ? baseURL : 'https://www.alintaenergy.com.au';
    var hasPaymentDetailsError = ((_b = formikState.errors) === null || _b === void 0 ? void 0 : _b.paymentDetails) !== undefined || !isCardValid;
    var isPaymentDetailsInvalid = ((_c = formikState.errors) === null || _c === void 0 ? void 0 : _c.paymentDetails) !== undefined;
    var hideButtons = paymentDetails.paymentTab === types_1.PaymentTab.PayPal;
    (0, myaccount_frontend_shared_1.useAnalyticsLoadV2)(ga, 'load.0.debitcreditform', (ga === null || ga === void 0 ? void 0 : ga.eventName) === 'process.web.payment' && paymentDetails.paymentTab === types_1.PaymentTab.CreditOrDebitCard);
    (0, myaccount_frontend_shared_1.useAnalyticsLoadV2)(ga, 'load.0.paypalform', (ga === null || ga === void 0 ? void 0 : ga.eventName) === 'process.web.payment' && paymentDetails.paymentTab === types_1.PaymentTab.PayPal);
    (0, react_1.useEffect)(function () {
        if (window && window.location) {
            var paypalUrl = window.location.search;
            var urlParams = new URLSearchParams(paypalUrl);
            var isPaypalResultPage = (urlParams === null || urlParams === void 0 ? void 0 : urlParams.has('SessionID')) && urlParams.has('SST');
            if (isPaypalResultPage && !steps.step3.isComplete) {
                completeStep(currentStepKey);
                goToStep('step3');
            }
            if (isPaypalResultPage && steps.step3.isComplete) {
                goToStep('step1');
                window.location.href = window.location.origin;
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var _j = (0, client_1.useMutation)(usePayWithPayPal_1.PAY_WITH_PAY_PAL, {
        onCompleted: function (result) {
            if (!result || !result.makePaypalPaymentWebsite.success) {
                completeStep(currentStepKey);
                goToStep('step3');
                return;
            }
            var redirectionURL = result.makePaypalPaymentWebsite.bamboraPaymentApiUrl + "?&SST=" + result.makePaypalPaymentWebsite.secureSessionToken + "&SessionID=" + result.makePaypalPaymentWebsite.sessionID;
            window.location.href = redirectionURL;
        },
        onError: function () {
            completeStep(currentStepKey);
            goToStep('step3');
            return;
        },
        fetchPolicy: 'no-cache'
    }), payWithPayPal = _j[0], paypalResult = _j[1];
    var isPayPalLoading = paypalResult.loading || paypalResult.called;
    var onTabChange = function (index) {
        formikState.setFieldValue('paymentDetails.paymentTab', index);
        if (index === types_1.PaymentTab.CreditOrDebitCard && (ga === null || ga === void 0 ? void 0 : ga.eventName) === 'process.web.payment') {
            ga === null || ga === void 0 ? void 0 : ga.push('click.4.debitcredittab');
        }
        if (index === types_1.PaymentTab.PayPal && (ga === null || ga === void 0 ? void 0 : ga.eventName) === 'process.web.payment') {
            ga === null || ga === void 0 ? void 0 : ga.push('click.3.paypaltab');
        }
    };
    var onPayWithPayPalClick = function (event) {
        var _a, _b, _c, _d, _e;
        event.preventDefault();
        if (!formikState.isValid || paypalResult.loading) {
            return;
        }
        ga === null || ga === void 0 ? void 0 : ga.push('click.1.paypalbutton');
        var urlParams = new URLSearchParams(window.location.search);
        // note: these form values should not be falsy as form would not be valid
        var dto = {
            reference: (_b = (_a = paymentDetails.accountNumber) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '',
            amount: Number(paymentDetails.paymentAmount),
            emailAddress: (_c = paymentDetails.emailAddress) !== null && _c !== void 0 ? _c : '',
            source: (urlParams === null || urlParams === void 0 ? void 0 : urlParams.has('mobile')) ? types_1.PaymentSource.MOBILE : types_1.PaymentSource.WEBSITE,
            accountNumber: (_e = (_d = paymentDetails.accountNumber) === null || _d === void 0 ? void 0 : _d.toString()) !== null && _e !== void 0 ? _e : ''
        };
        payWithPayPal({
            variables: {
                paypalPaymentInput: dto
            }
        });
    };
    var onContinueClick = function () {
        if (!instance) {
            return;
        }
        setLoading(true);
        try {
            instance.createOneTimeToken(guid, function (result) {
                if (result.code <= 200) {
                    setLoading(false);
                    return;
                }
                var callbackResult = (0, tslib_1.__assign)((0, tslib_1.__assign)({}, result), { savePaymentToken: result.token, name: formikState.values.paymentDetails.cardName });
                onSubmit(callbackResult, cardType);
                completeStep(currentStepKey);
                setLoading(false);
                goToStep(nextStepKey);
            });
        }
        catch (e) {
            setLoading(false);
        }
    };
    if (!instance) {
        return null;
    }
    return (react_1.default.createElement(components_1.Content, { header: {
            hide: false,
            title: 'Make a payment'
        }, footer: {
            hide: hideButtons,
            leftButton: {
                label: 'Cancel',
                disabled: loading ? true : false,
                onClick: function () {
                    if (paymentDetails.paymentTab === types_1.PaymentTab.CreditOrDebitCard && (ga === null || ga === void 0 ? void 0 : ga.eventName) === 'process.web.payment') {
                        ga === null || ga === void 0 ? void 0 : ga.push('click.2.debitcreditcancel');
                    }
                    onCancel();
                }
            },
            rightButton: {
                label: 'Continue',
                loading: loading,
                disabled: formikState.dirty === false || hasPaymentDetailsError,
                onClick: function () {
                    if (paymentDetails.paymentTab === types_1.PaymentTab.CreditOrDebitCard && (ga === null || ga === void 0 ? void 0 : ga.eventName) === 'process.web.payment') {
                        ga === null || ga === void 0 ? void 0 : ga.push('click.3.debitcreditcontinue');
                    }
                    onContinueClick();
                }
            }
        } },
        react_1.default.createElement(asg_1.Box, { margin: {
                horizontal: responsiveSize === 'xs' ? 'none' : 'xsmall'
            } },
            react_1.default.createElement(asg_1.Heading, { level: 4, weight: 700 }, "Payment details"),
            react_1.default.createElement(asg_1.Box, { margin: {
                    top: responsiveSize === 'xs' ? 'xsmall' : 'medium',
                    bottom: 'none'
                } },
                react_1.default.createElement(components_1.UnAuthenticatedDetails, { ga: ga }),
                react_1.default.createElement(components_1.PaymentAmount, { disabled: loading, ga: ga }),
                react_1.default.createElement(components_1.EmailAddress, { ga: ga })),
            react_1.default.createElement(asg_1.Box, { margin: {
                    top: responsiveSize === 'xs' ? 'xsmall' : 'medium',
                    bottom: 'small'
                } },
                react_1.default.createElement(asg_1.Heading, { level: "3", weight: 700 }, "Payment method"),
                ' '),
            react_1.default.createElement(TabGroup_1.default, { tabs: tabTitles, activeTabIndex: (_d = paymentDetails.paymentTab) !== null && _d !== void 0 ? _d : 0, onTabChange: onTabChange }),
            react_1.default.createElement(asg_1.Box, { style: { display: paymentDetails.paymentTab === types_1.PaymentTab.CreditOrDebitCard ? '' : 'none' } },
                react_1.default.createElement(asg_1.Box, { margin: {
                        top: '24px',
                        bottom: responsiveSize === 'xs' ? 'small' : 'xsmall'
                    } },
                    react_1.default.createElement(asg_1.Notification, { type: "custom", icon: react_1.default.createElement(asg_1.Icon, { id: "notification", icon: icons_1.Info, width: "20px", height: "20px", fill: asg_1.colors['primaryBlue-1'] }), pad: { horizontal: 'small', vertical: 'small' }, message: react_1.default.createElement(asg_1.Text, { size: "13px", lineHeight: "20px" },
                            "Alinta Energy collects your information and shares it with our third party payment providers so that we can process your payment. If you do not provide this information we may not be able to process your payment. For more information about how we manage your information, how you can access and correct your information or make a complaint, you can read our",
                            ' ',
                            react_1.default.createElement(asg_1.Link, { target: '_blank', href: appBaseUrl + '/help-and-support/terms-and-conditions/privacy-policy', size: "13px", onClick: function () { return ga === null || ga === void 0 ? void 0 : ga.push('click.1.debitcreditprivacypolicy'); }, color: asg_1.colors['colour-secondary'] }, "Privacy Policy"),
                            ' ',
                            "on our website.") })),
                react_1.default.createElement(components_1.CreditCard, { sectionKey: exports.SECTION_KEY, instance: instance, onError: function () { return setIsCardValid(false); }, onComplete: function (cardType) {
                        setIsCardValid(true);
                        setCardType(cardType);
                    }, disabled: loading })),
            react_1.default.createElement(asg_1.Box, { style: {
                    display: paymentDetails.paymentTab === types_1.PaymentTab.PayPal ? 'flex' : 'none',
                    alignItems: 'center',
                    height: '500px',
                    paddingTop: '100px'
                } },
                react_1.default.createElement(asg_1.Box, { style: { fontSize: '16px', maxWidth: '320px', width: '100%', height: '60px', textAlign: 'center' } }, "You will be redirected to the PayPal site to complete payment"),
                react_1.default.createElement(PayPalButton_1.default, { disabled: isPaymentDetailsInvalid, onClick: onPayWithPayPalClick, loading: isPayPalLoading })))));
};
exports.UnAuthenticated = UnAuthenticated;
exports.default = exports.UnAuthenticated;
//# sourceMappingURL=UnAuthenticated.js.map